import { Component, OnInit, ElementRef, Input, Output, EventEmitter, SimpleChanges, Renderer2, ViewChild } from '@angular/core';
import * as WebUploader2 from 'webuploader'
import { environment } from 'src/environments/environment';
import { Md5 } from 'ts-md5/dist/md5';
import Cropper from 'cropperjs'
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwMassageConfirmComponent } from '../sw-massage-confirm/sw-massage-confirm.component';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { SwPhotoAlbumService } from '../sw-photo-album/sw-photo-album.service';
import { SwModalframeComponent } from '../sw-modal-frame/sw-modal-frame.component';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwUploadCutBoxComponent } from './sw-upload-cut-box/sw-upload-cut-box.component';
import { DomSanitizer } from '@angular/platform-browser';


/**
 * 创建人：袁俊双
 * 
 * 时间：2019-4-1
 * 
 * 描述：头像上传的使用说明
 * 
 * 使用说明: 参考 sw-auto-upload 配置应用说明文档
 * 
 * 更新说明:
 * 
 * 1.单张图片上传功能
 * 
 * 2.添加剪切之后上传的功能 by yuanjs
 * 
 * 3.添加删除和下载的按钮 by yuanjs
 * 
 */
@Component({
  selector: 'sw-auto-upload',
  templateUrl: './sw-auto-upload.component.html',
  styleUrls: ['./sw-auto-upload.component.css']
})
export class SwAutoUploadComponent implements OnInit {

  /**
   * 父组件传递过来的值,用于一个页面上同时有两个相同的组件,需要使用不同的id,如果只用一次,就不需要传递此值
   */
  @Input() label1: string;

  /**
   * 是否为查看状态,默认是编辑状态,查看状态不能上传,编辑状态可以上传
   */
  @Input() autoReadOnly: boolean = false

  /**
   * 业务id  如果有图片需要一开始就展示出来,就使用策略和业务id来获取图片进行展示
   */
  @Input() autoBusinessId: string

  /**
   * 回填图片的id
   */
  @Input() autoImgId: string

  /**
   * 回填图片的路径,是相对路径+fileName
   */
  @Input() autoImgURL: string

  /**
   * 父组件传递过来的宽高配置,如果不传,此为默认 100 x 100
   */
  @Input() myStyle: any = {
    width: '100px',
    height: '100px'
  }

  /**
   * 上传前配置项的查询,根据父组件传递过来的值进行查询,functionId  或者是 code 任一种,不传就默认配置
   */
  @Input() autoFunctionId: string

  /**
   * 上传前配置项的查询,根据父组件传递过来的值进行查询,functionId  或者是 code 任一种,不传就默认配置
   */
  @Input() autoCode: string

  /**
   * 上传前配置项的查询,根据父组件传递过来的值进行查询,functionId  或者是 code 任一种,不传就默认配置
   */
  @Input() cropperHeight:string

  /**
   * 存放要发送给父组件的文件信息,上传的文件数据 uploadedFilesInfo
   */
  @Output() autoInfoToSubmit = new EventEmitter()

  /**
   * 存放要发送给父组件的文件信息,删除的文件数据
   */
  @Output() autoInfoToDelete = new EventEmitter()

  /**
   * 输出属性,将设置为封面图的文件抛出
   */
  @Output() fileSetAsCover = new EventEmitter()

  /**
   * @ignore
   * 存放已经上传的文件的信息
   */
  uploadedFilesInfo: any[] = []

  /**
   * @ignore
   * webUploader 文件上传初始化的 uploader
   */
  autoUploader2: any

  /**
   * @ignore
   * 是否需要裁剪后再上传
   */
  isCropper: boolean = false

  /**
   * @ignore
   * 裁剪的图片img元素
   */
  image: any

  /**
   * @ignore
   * 新建的裁剪对象
   */
  cropper: any

  /**
   * @ignore
   * 待上传文件
   */
  waitToUploadImg: any

  /**
   * @ignore
   * 上传路径--输入属性，如果业务端不传此参数，那么就将空值传入上传接口，后台会判断是否有值，没有的话，后台会从策略中读取
   */
  @Input() uploadPath: string = ''

  /**
   * @ignore
   * 初始化上传组件时的背景图片url(assets/Images/upload.png),前提是组件  autoReadOnly = false,创建 webuploader
   */
  // initUrl:any = "url(assets/Images/upload.png)"

  /**
   * @ignore
   * 初始化上传组件时的图片 assets/Images/upload.png,前提是组件  autoReadOnly = true,不创建 webuploader
   */
  initUrl: any = "assets/Images/upload.png"

  /**
   * @ignore
   * 根据策略查询配置是否成功,如果没有成功,就展示假上传按钮,默认成功
   */
  getOptionSuccess: boolean = true

  /**
   * @ignore
   * 上传请求的根路径
   */
  autoUrl: string = environment.fileWebAPI

  /**
   * @ignore
   * 是否确认组件
   */
  @ViewChild("tirm") tirm: SwMassageConfirmComponent;

  /**
   * 常量配置模态框
   * @ignore
   */
  @ViewChild("cutModal") cutModal: SwModalframeComponent;

  /**
   * @ignore
   * 组件显示的文件
   */
  file: any[] = []

  /**
   * @ignore
   * 文件策略配置中是否允许设置封面图,默认不能
   */
  isCover: boolean = false;
  /**
   * 根据策略得到的提示语前面增加的提示语
   */
  @Input() addtip: string

  /**
 * @ignore
 * 决定是否显示存放根据策略得到的提示语
 */
  @Input() showTip: boolean = true
  /**
   * @ignore
   * 存放根据策略得到的提示语
   */
  tip: any
  /**
  * @ignore
  * 选择的文件到上传队列之后有没有出现错误,默认没有，如果有，之后的 this.fileUploader.on('error',(type)=>{}） 里面就不要再次提示了
  */
  hasError: boolean = false
  /**
   * @ignore
   * 是否上传中
   */
  isUploading: boolean = false
    /**
 * @ignore
 * 提示语是否宽100%
 */
     @Input() showTipFull: boolean = false
  /**
   * @ignore
   */
  constructor(
    private el: ElementRef,
    private renderer2: Renderer2,
    private http: SwHttpClientService,
    private Jwt: SwJwtService,
    private box: SwMassageBoxService,
    private systemId: SystemIdService,
    public popup: SwPhotoAlbumService,
    private getUserModelService: GetUserModelService,
    private create: SwCreateModalComponentService,
    private sanitization: DomSanitizer
  ) { }

  /**
   * @ignore
   * 创建上传对象需要的参数
   */
  options2 = {
    server: environment.fileWebAPI + "file/fileUpload", //文件接收服务器
    auto: true,   //选完文件后是否自动上传
    resize: false,
    dnd: '#uploader',   //指定 Drag And Drop 拖拽的容器,如果不知道,择不启动
    paste: '#uploader',  //指定监听paste事件的容器,如果不指定则不起都过此功能.此功能为通过粘贴来添加截屏的图片,建议设置为document.body
    pick: {
      id: '#autoPicker',
      label: '',
      multiple: false,   //是否能够多个文件上传,数据从父组件传递过来
    },
    fileNumLimit: 1,
    accept: {   //只允许上传图片文件
      title: '',
      extensions: 'gif,jpg,jpeg,bmp,png',  //后缀类型
      // mimeTypes: 'image/*',
      //点击选择文件之后会有延迟,解决方法:
      mimeTypes: 'image/gif,image/jpg,image/jpeg,image/png,image/bmp'
    },
    fileSingleSizeLimit: undefined,  //单个文件大小限制
    compress: false,   //上传之前不压缩
    chunked: true,     //分片上传大文件
    chunkSize: 1024 * 512,  //分片大小
    chunkRetry: 3,     // 如果某个分片由于网络出现问题错误,允许自动上传多少次
    threads: 5,        //最大上传并发数
    method: 'Post',  //上传请求方式
    duplicate: true,   //允许重复上传文件 
  }

  /**
   * @ignore
   * ngOnChanges()
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.label1 || changes.autoReadOnly || changes.autoBusinessId || changes.autoImgId || changes.autoImgURL || changes.myStyle || changes.autoFunctionId || changes.autoCode) {  //只要输入属性某一项改变,就将此函数中的代码都执行一次,重新创建上传对象
      this.label1 = this.label1 || 'autoPicker';
      this.options2.pick.id = this.label1 ? '#' + this.label1 : '#autoPicker'
      this.echo(this.autoImgId, this.autoImgURL)

      //autoReadOnly : 如果父组件传入了此值是查看状态,不再继续往下运行代码,不创建上传对象
      if (this.autoReadOnly) {
        //查看状态展示假按钮,就只回显就行了
        this.getOptionSuccess = false
        return
      } else {
        //如果不是查看状态就可查询code创建上传组件了
        if (this.autoFunctionId || this.autoCode) {
          if (this.label1) {
            this.options2.pick.id = '#' + this.label1
          } else {
            this.label1 = 'autoPicker'
            this.options2.pick.id = '#' + this.label1
          }
          //根据策略id查询到上传配置项,比如文件后缀类型,是否允许多个文件上传,上传文件的大小等
          if (this.autoFunctionId) {
            this.http.Get(this.autoUrl + 'fileConfig/queryFileConfigOfUploadBeforeByFunctionId?functionId=' + this.autoFunctionId)
              .subscribe(ret => {
                if (ret && ret.code == 200) {
                  let uploadObj = ret.data;
                  if (uploadObj.config.status == true) {
                    let suffix = uploadObj.suffix ? JSON.parse(JSON.stringify(uploadObj.suffix)) : ''
                    let suffixstr = suffix.replace(/,/g, '、')
                    this.tip = '（允许上传类型：' + (suffixstr || '请在上传策略中配置允许上传类型') + '；' + ' 允许上传图片大小：' + (uploadObj.config.allowSize ? uploadObj.config.allowSize + 'M；' : '无限制；') + (uploadObj.config.tip ? ' ' + uploadObj.config.tip : '') + '）'
                    //this.tip = '(允许上传类型:'+ (uploadObj.suffix || '请在上传策略中配置允许上传类型') +'; '+'允许上传图片大小:'+ (uploadObj.config.allowSize? uploadObj.config.allowSize +'M; ' : '无限制; ') + (uploadObj.config.tip?uploadObj.config.tip:'') + ')'
                    this.isCover = uploadObj.isCover  //策略里面允许设置为封面图
                    this.options2.fileSingleSizeLimit = uploadObj.config.allowSize ? uploadObj.config.allowSize * 1024 * 1024 : undefined;  //允许上传大小
                    this.options2.pick.multiple = uploadObj.multiple    //是否允许多张上传
                    this.options2.accept.extensions = uploadObj.suffix  //配置项的上传类型
                    this.options2.accept.mimeTypes = uploadObj.type     //配置项的上传类型
                    this.options2.auto = uploadObj.isCut ? false : true;   //是否自动上传
                    // this.uploadPath = uploadObj.config.filePath       //上传请求中的参数--文件保存路径
                    this.autoUploader2 = WebUploader2.create(this.options2)  //创建上传对象
                    this.clickToSelect();   //绑定上传相关事件
                    this.setThisStyle()     //设置上传组件样式
                    this.getOptionSuccess = true  //正常展示
                  } else {
                    //查询到的策略禁用
                    this.box.danger("此策略已禁用")
                    this.getOptionSuccess = false  //展示假按钮
                  }
                } else {
                  //查询失败
                  this.box.danger("策略查询失败")
                  this.getOptionSuccess = false  //展示假按钮
                }
              })
          }
          if (this.autoCode) {
            //是超级管理员则需要传递当前系统
            this.http.Get(this.autoUrl + 'fileConfig/queryFileConfigOfUploadBeforeByCode?code=' + this.autoCode)
              .subscribe(ret => {
                if (ret && ret.code == 200) {
                  let uploadObj = ret.data;
                  if (uploadObj.config.status == true) {
                    let suffix = uploadObj.suffix ? JSON.parse(JSON.stringify(uploadObj.suffix)) : ''
                    let suffixstr = suffix.replace(/,/g, '、')
                    this.tip = '（允许上传类型：' + (suffixstr || '请在上传策略中配置允许上传类型') + '；' + ' 允许上传图片大小：' + (uploadObj.config.allowSize ? uploadObj.config.allowSize + 'M；' : '无限制；') + (uploadObj.config.tip ? ' ' + uploadObj.config.tip : '') + '）'
                    //this.tip = '(允许上传类型:'+ (uploadObj.suffix || '请在上传策略中配置允许上传类型') +'; '+'允许上传图片大小:'+ (uploadObj.config.allowSize? uploadObj.config.allowSize +'M; ' : '无限制; ') + (uploadObj.config.tip?uploadObj.config.tip:'') + ')'
                    this.isCover = uploadObj.isCover  //策略里面允许设置为封面图
                    this.options2.fileSingleSizeLimit = uploadObj.config.allowSize ? uploadObj.config.allowSize * 1024 * 1024 : undefined;  //允许上传大小
                    this.options2.pick.multiple = uploadObj.multiple    //是否允许多张上传
                    this.options2.accept.extensions = uploadObj.suffix  //配置项的上传类型
                    this.options2.accept.mimeTypes = uploadObj.type     //配置项的上传类型
                    this.options2.auto = uploadObj.isCut ? false : true;   //是否自动上传
                    // this.uploadPath = uploadObj.config.filePath       //上传请求中的参数--文件保存路径
                    this.autoUploader2 = WebUploader2.create(this.options2)  //创建上传对象
                    this.clickToSelect();   //绑定上传相关事件
                    this.setThisStyle()     //设置上传组件样式
                    this.getOptionSuccess = true  //正常展示
                  } else {
                    //查询到的策略禁用
                    this.box.danger("此策略已禁用")
                    this.getOptionSuccess = false  //展示假按钮
                  }
                } else {
                  //查询失败
                  this.box.danger("策略查询失败")
                  this.getOptionSuccess = false  //展示假按钮
                }
              })
          }
        } else {
          if (this.label1) {
            this.options2.pick.id = '#' + this.label1
          }
        }
      }

    }

  }

  /**
   * @ignore
   * ngOnInit()
   */
  ngOnInit() {
    if (!this.autoFunctionId && !this.label1 && !this.autoCode && !this.autoReadOnly) {
      this.tip = '（没有上传策略，默认允许上传类型：gif、jpg、jpeg、bmp、png)'
      //this.tip = '(没有上传策略,默认允许上传类型：gif，jpg，jpeg，bmp，png)'
      //只有父组件没有要求上传配置时,直接按照默认配置创建上传实例
      this.label1 = 'autoPicker'
      this.options2.pick.id = '#' + this.label1
    }
    //不管父组件有没有规定大小,都设置宽高
    this.el.nativeElement.querySelector(".auto-webuploader-container").style.width = this.myStyle.width;
    this.el.nativeElement.querySelector(".auto-webuploader-container").style.height = this.myStyle.height;
  }

  /**
   * @ignore
   * ngAfterViewInit() 
   */
  ngAfterViewInit(event) {
    //在不是查看状态的前提下,如果不是通过异步请求之后再创建上传对象,就创建默认对象,如果是异步创建对象,就在请求成功之后直接创建,不然因为请求时间问题,还是创建的默认上传对象
    if (!this.autoCode && !this.autoFunctionId && !this.autoReadOnly) {
      this.autoUploader2 = WebUploader2.create(this.options2)
      this.clickToSelect();
      this.setThisStyle()
      this.getOptionSuccess = true  //正常展示
    }
  }

  /**
   * @ignore
   * @param autoImgId  图片的fileInfoId
   * @param autoImgURL  图片的绝对路径
   * echo() 回显的方法
   */
  echo(autoImgId, autoImgURL) {
    if (this.options2.auto == false) {  //确认裁剪
      //如果是裁剪状态,刷新的时候需要将裁剪的状态改变为回显的状态
      this.isCropper = false
    }
    //autoImgId : 如果父组件传入了此值就在组件上展示回填图片
    if (autoImgId || autoImgURL) {
      //如果有图片就回填
      let param = {
        'fileInfoId': autoImgId || "",
        'fileName': autoImgURL ? autoImgURL.substring(autoImgURL.lastIndexOf('/') + 1) : ""
      }
      this.http.Post(this.autoUrl + "fileInfo/queryPageList", param).subscribe(
        result => {
          if (result && result.code == 200) {
            this.file = result.data.records
            if (this.file.length) {
              //如果查询到了数据,就显示图片
              this.initUrl = environment.staticFileUrl + this.file[0].filePath + this.file[0].fileName   //img图片地址
            } else {
              //查询不到数据,就显示初始化图片,并进行提示,以免上传区域空白
              this.initUrl = "assets/Images/upload.png"
            }
          } else {
            // this.box.danger('图片回显失败')
          }
        })
    }
    //在autoImgId 或者 autoImgURL 重新置为空的时候,这两个值都没有了,需要将回显图片设置为默认值
    if (!autoImgId && !autoImgURL) {
      this.file = []  //将回显图片的按钮清空
      this.initUrl = "assets/Images/upload.png"
    }
  }

  /**
   * 头像上传组件的刷新方法,当父组件上传后,点击取消等操作的时候,需要将组件刷新,避免再次上传的时候还有之前的痕迹
   */
  uploaderRefresh() {
    this.echo(this.autoImgId, this.autoImgURL)
  }

  /**
   * @ignore
   * setThisStyle() 设置样式的方法
   */
  setThisStyle() {
    //由于创建上传实例完毕后,有新增的标签,所以要在实例可见之后再修改元素样式
    this.el.nativeElement.querySelector('.auto-webuploader-container .wu-example').style.width = this.myStyle.width
    this.el.nativeElement.querySelector('.auto-webuploader-container .webuploader-pick').style.width = this.myStyle.width
    this.el.nativeElement.querySelector('.auto-webuploader-container .webuploader-pick').style.height = this.myStyle.height
    this.el.nativeElement.querySelector('.auto-webuploader-container .webuploader-pick').style.padding = 0
    this.el.nativeElement.querySelector('.auto-webuploader-container .wu-example').style.height = this.myStyle.height
    this.el.nativeElement.querySelector('.auto-webuploader-container .selectBtn').style.height = this.myStyle.height
    // //上传组件的图片已背景图形式展示,上传成功后也是更换背景图
    this.el.nativeElement.querySelector('.auto-webuploader-container .webuploader-pick').style.backgroundRepeat = 'no-repeat'
    this.el.nativeElement.querySelector('.auto-webuploader-container .webuploader-pick').style.backgroundPosition = 'center center'
    this.el.nativeElement.querySelector('.auto-webuploader-container .webuploader-pick').style.backgroundColor = 'transparent'
    this.el.nativeElement.querySelector('.auto-webuploader-container .webuploader-pick').style.backgroundSize = 'contain'
    this.el.nativeElement.querySelector('.auto-webuploader-container .webuploader-pick').style.border = '1px solid #ccc'
    // //bug : 按照 auto -- file -- img 顺序排列时, auto label元素位置不正确,要调整窗口大小后正常使用, 解决方法: 上传实例可见之后刷新
    this.autoUploader2.refresh()

    //bug: 水印管理的输入属性不是同时传入的,上传对象创建了两次,dom元素页添加了两次,上传后图片显示不正确
    let pick = this.el.nativeElement.querySelector('.auto-webuploader-container .webuploader-pick')
    if (pick.childNodes.length != 0) {
      for (var i = pick.childNodes.length; i--; i >= 0) {
        this.renderer2.removeChild(pick, pick.childNodes[i])
      }
    }
  }


  //裁剪之后的回调
  cutCallback(data?) {
    if (data.cutted && data.blob) {
      //如果经过裁剪
      let blob = data.blob
      this.autoUploader2.removeFile(this.waitToUploadImg, true)
      this.autoUploader2.reset()
      blob['cutted'] = true
      blob["name"] = this.waitToUploadImg.name   //裁剪后的图片名与裁剪前一致
      this.autoUploader2.addFiles(blob)   //将文件加入到队列中,哪怕加入的是blob格式,之后也会自动转化为 WUFile
      setTimeout(() => {
        this.autoUploader2.upload()
      }, 500)
    } else {
      //直接将未裁剪的图片上传
      this.waitToUploadImg.source.source.cutted = true
      this.autoUploader2.addFiles(this.waitToUploadImg)
      setTimeout(() => {
        this.autoUploader2.upload()
      }, 500)
    }
  }

  /**
   * @ignore
   * clickToSelect() 点击选择文件,自动开始上传
   */
  clickToSelect() {
    //重置队列,不然不能再次选择文件上传

    this.autoUploader2.reset()
    this.autoUploader2.refresh()

    //文件加入到队列之前
    this.autoUploader2.on('beforeFileQueued', (file) => {
      //每次有文件加入队列，先把 hasError初始化一下
      this.hasError = false
      if (this.options2.accept.extensions && this.options2.accept.extensions.indexOf(file.ext.toLocaleLowerCase()) == -1) {
        //在加入队列之前就发现错误，不能上传该文件，之后的 this.fileUploader.on('error',(type)=>{}） 里面就不要再次提示了
        this.hasError = true
        //没有这个后缀
        this.box.danger('图片格式不正确')
        return
      }
      if (file.size > this.options2.fileSingleSizeLimit) {
        //在加入队列之前就发现错误，不能上传该文件，之后的 this.fileUploader.on('error',(type)=>{}） 里面就不要再次提示了
        this.hasError = true
        this.box.danger(file.name + '大小超过限制')
        return
      }
      if (file.size == 0) {
        //在加入队列之前就发现错误，不能上传该文件，之后的 this.fileUploader.on('error',(type)=>{}） 里面就不要再次提示了
        this.hasError = true
        this.box.danger(file.name + ' 的图片大小为0KB，请选择其他图片上传')
        return
      }
      if (this.options2.auto == false) {  //确认配置中有裁剪功能
        if (file.source.source.cutted !== true) {  //如果不是已经经过裁剪后 加入队列的图片，就打开裁剪模态框进行裁剪
          this.isCropper = true
          let p = {
            myStyle: this.myStyle,
            waitToUploadImg: file,
            file: file,
            height:this.cropperHeight
          }
          this.create.createModal(SwUploadCutBoxComponent, p, this.cutCallback.bind(this))
        }
        //之前的待上传文件与新加入队列的文件大小不一样,文件名一样,说明取消了裁剪,直接上传原图
        if (this.waitToUploadImg) {
          if (file.size == this.waitToUploadImg.size && file.name == this.waitToUploadImg.name) {

          } else {
            //如果之前队列中有文件,就清空队列
            this.autoUploader2.removeFile(this.waitToUploadImg, true)
            this.autoUploader2.reset()
            this.autoUploader2.refresh()
          }
        }
      }
    })

    //文件加入队列时触发,此时将图片放在上传区域
    this.autoUploader2.on("fileQueued", (file) => {
      this.isUploading = true
      // this.el.nativeElement.querySelector('.flag').innerHTML = ''  //再次上传时,成功的标志隐藏
      if (this.options2.auto == false) {  //裁剪后上传
        this.waitToUploadImg = file
      }
    })

    //文件上传之前触发,设置参数
    this.autoUploader2.on('uploadBeforeSend', (obj, data, headers) => {
      //增加请求头,
      headers['AuthorizationU'] = this.Jwt.getToken('token'),
        data.id = obj.file.id,              //wu_id,webUpload组件自己排的ID，通过此参数获取相应MD5值
        data.size = obj.file.size,          //文件总文件字节大小
        data.byteNow = obj.blob.size,       //定义的每个分片的字节大小
        data.chunks = obj.chunks,           //总分片数
        data.chunk = obj.chunk,             //当前分片数，当前是第几分片
        data.name = obj.file.name,          //文件名
        data.file = JSON.stringify(obj.blob),  //分片对象
        // data.md5 = Md5.hashStr(obj.file.id + ':'+obj.file.name + obj.file.lastModifiedDate+'#'),        //将md5值进行Md5加密 , 文件的MD5值String , 后台根据这个md5值进行分片的合并,所以,每一个文件的所有分片的md5要一致
        data.sysId = this.systemId.getSystemId(),                    //系统编号,也是文件中心的所属系统
        // data.functionId = this.autoFunctionId ? this.autoFunctionId : '1',                //策略id
        data.code = this.autoCode ? this.autoCode : 'DEFAULT',                //策略id
        data.uploadPath = this.uploadPath,              //上传路径,随便写的字符串
        data.uploadDirectory = environment.uploadDirectory           //项目路径
    })


    //上传成功触发
    this.autoUploader2.on('uploadSuccess', (file, response) => {
      if (response.code == 200) {
        //将上传成功的文件信息传递给父组件
        this.http.Post(this.autoUrl + "fileInfo/queryPageList", { 'fileInfoId': response.data.uuid })
          .subscribe(
            result => {
              if (result.code == 200) {
                //将组件展示的文件进行替换
                this.file = result.data.records
                //根据路径进行图片回显: environment.staticFileUrl+item.filePath+item.fileName;
                if (this.file.length) {
                  let item = this.file[0]
                  this.initUrl = environment.staticFileUrl + item.filePath + item.fileName
                  this.autoInfoToSubmit.emit(result.data.records)
                  // setTimeout(()=>{
                  //   this.isUploading = false
                  // },500)
                  var img = new Image();
                  img.src = this.initUrl;
                  img.onload = () => {
                    this.isUploading = false
                  };
                } else {
                  this.isUploading = false
                }

              } else {
                this.isUploading = false
              }
            }
          )
        if (this.options2.auto == false) {
          this.isCropper = false
        }
      } else {
        this.isUploading = false
        //相当于上传失败
        this.box.danger(response.msg)
      }
      this.autoUploader2.removeFile(file, true)
      this.autoUploader2.reset()
      this.autoUploader2.refresh()
    })
    //上传失败触发
    this.autoUploader2.on('uploadError', (file, reason) => {
      this.isUploading = false
      //this.box.danger("上传失败")
    })
    //校验不通过时发生
    this.autoUploader2.on('error', (type) => {
      //如果这里的校验没通过，而加入到队列时没发现这个问题，就提示
      if (type == 'Q_TYPE_DENIED' && !this.hasError) {
        this.box.danger('图片校验不通过')
      }
    })
  }

  /**
   * @ignore
   * deteleFile() 点击已经上传的文件的删除按钮,将文件从数据库删除 post请求: fileInfo/delete?id=** , 删除后的文件的状态改变
   */
  deteleFile() {
    this.tirm.openCLick("确认删除吗？", (data) => {
      if (data == true) {
        let data = {
          'ids': [String([this.file[0].fileInfoId])]
        }
        this.http.Post(this.autoUrl + 'fileInfo/deleteBatch', data)
          .subscribe(res => {
            if (res.code == 200) {
              //将删除的文件信息传递给父组件
              this.autoInfoToDelete.emit(this.file)
              //要展示的文件清空
              this.file = []
              //将背景图替换
              this.initUrl = "assets/Images/upload.png"
            } else {
              this.box.danger("删除失败")
            }
          })
      }
    })
  }

  /**
   * @ignore
   * downloadFile() 点击已经上传的文件的下载按钮,将文件下载到本地
   */
  downloadFile() {
    // window.location.href = this.autoUrl + "fileDownload/download?fileId="+this.file[0].fileInfoId;
    //可行，360没有跳转
    var elemIF = document.createElement("iframe");
    elemIF.src = this.autoUrl + "fileDownload/download?fileId=" + this.file[0].fileInfoId;
    elemIF.style.display = "none";
    document.body.appendChild(elemIF);
    setTimeout(() => {
      document.body.removeChild(elemIF)
    }, 3000);
  }

  /**
   * @ignore
   * 查看状态的图片预览功能
   */
  view() {
    //如果是图片格式点击就预览,其他格式就下载 , 注意此时的文件后缀有大写的,转化为小写,再看是否预览
    if (this.file[0].fileSuffix.toLocaleLowerCase() == 'jpg' || this.file[0].fileSuffix.toLocaleLowerCase() == 'jpeg' || this.file[0].fileSuffix.toLocaleLowerCase() == 'png' || this.file[0].fileSuffix.toLocaleLowerCase() == 'bmp' || this.file[0].fileSuffix.toLocaleLowerCase() == 'gif') {
      let photosData = { path: [environment.staticFileUrl + this.file[0].filePath + this.file[0].fileName], index: 0 };
      this.popup.showPhotoAlbum(photosData);
    } else {
      window.location.href = environment.fileWebAPI + "fileDownload/download?fileId=" + this.file[0].fileInfoId;
    }
  }

  //设置为封面图
  setAsCover() {
    this.fileSetAsCover.emit(this.file[0])
  }

}
